import {
    Backdrop,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Divider,
    Grid,
    TableHead,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
    ThemeProvider,
    createMuiTheme,
    TextField,
    Button
  } from '@material-ui/core';
  import { sc } from 'src/utils/Common';
  import DateFnsUtils from '@date-io/date-fns';
  import { makeStyles } from '@material-ui/styles';
  import clsx from 'clsx';
  import PropTypes from 'prop-types';
  import SearchIcon from '@material-ui/icons/Search';
  import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
  import React, { useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  import trLocale from 'date-fns/locale/tr';
  import { connect } from 'react-redux';
  import axios from 'src/utils/axios';
  import { getUser } from 'src/utils/Common';
  import SearchBar from 'material-ui-search-bar';
  import moment from 'moment';
  const useStyles = makeStyles((theme) => ({
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0)
    },
    cardscontent: {
      minHeight: 300,
    },
    tableRow: {
      '&$hover:hover': {
        backgroundColor: '#f5f5f5'
      }
    },
    tableCell: {
      '$hover:hover &': {
        color: 'black'
      }
    },
    hover: {},
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    container: {
      maxHeight: 630,
    },
  }));
  
  
  function BomListLibrary({ className, ReceiptNo, readonly, tasks }) {
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const SessionUser = getUser();
    const BirimKodu = SessionUser.ServiceShopId;
    const TeknisyenKodu = SessionUser.TechnicianId;
    const [Loading, setLoading] = useState(true);
    const [searched, setSearched] = useState('');
    const [BomData, setBomData] = useState([]);
    const [BomDataRows, setBomDataRows] = useState([]);
    const [SerialNr, setSerialNr] = useState('');
    const [StartDateSearch, setStartDateSearch] = useState(
      moment()
        .startOf('day')
        .add(-7, 'days')
        .add(12, 'hours')
        .format('YYYY-MM-DD')
    );
    const Data = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    const Model = Data && Data[0] && Data[0].ModelCode;
    const user = getUser();
    const localeMap = {
      tr: trLocale
    };
    const locale = localStorage.getItem('i18nextLng');
    const siyah = '#424242';
    const materialTheme = createMuiTheme({
      palette: {
        primary: {
          contrastText: '#FFFFFF',
          dark: siyah,
          main: siyah,
          light: siyah
        }
      }
    });
  
    useEffect(() => {
      let mounted = true;
      const fetchTodos = () => {
        let ModelParam = '-1';
        if (Model !== '') {
          ModelParam = Model;
        }
        axios
          .get(`/GetBomList/1/${ModelParam}/${StartDateSearch}/${SerialNr || '0'}`)
          .then(response => {
            if (mounted) {
              const ResponseData = response.data === '' ? [] : response.data;
              setBomData(ResponseData);
              setBomDataRows(ResponseData);
              setLoading(false);
            }
          })
          .catch(error => {
            setLoading(false);
          });
      };
      fetchTodos();
      return () => {
        mounted = false;
      };
    }, [ReceiptNo, BirimKodu, TeknisyenKodu, Model]);
  
    const GetHisBomList = () => {
      setLoading(true);
      let ModelParam = '-1';
        if (Model !== '') {
          ModelParam = Model;
        }
      axios
      .get(`/GetBomList/2/${ModelParam}/${StartDateSearch}/${SerialNr || '0'}`)
        .then(response => {
          if (response.data.length > 0) {
            setBomData(response.data);
            setBomDataRows(response.data);          
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
         });
    };
  
  
    const cancelSearch = () => {
      setSearched('');
      requestSearch(searched);
    };
    const requestSearch = (searchedVal) => {
      const filteredRows = BomData.filter((item) => sc(item.MaterialCode + item.Material + item.Ref + item.PriceCode, searchedVal));
      setBomDataRows(filteredRows);
    };
    const handleChangeStartDateSearch = e => {
      setStartDateSearch(e);
    };

  
    return (
      <div>
        <Card className={clsx(classes.root, className)}>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <CardHeader title={t('Bom')} />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={4} lg={4}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="StartDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('lblDate')}
                      variant="outlined"
                      value={StartDateSearch}
                      onChange={e => handleChangeStartDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={4} sm={4} lg={4}>
                <TextField
                  size="small"
                  id="SerialNr"
                  autoComplete="no"
                  value={SerialNr}
                  onChange={event => setSerialNr(event.target.value)}
                  fullWidth
                  label={t('lblSerialNr')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={4} sm={4} lg={4}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<SearchIcon />}
                  onClick={GetHisBomList}
                >
                  {t('search')}
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <SearchBar
                  value={searched}
                  onChange={searchVal => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                  placeholder={t('lblSearch')}
                  style={{ margin: '0 auto', maxWidth: '100%', maxHeight: 37 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TableContainer className={classes.container}>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">{t('lblRef')}</TableCell>
                        <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                        <TableCell align="left">{t('lblMaterial')}</TableCell>
                        <TableCell align="left">{t('lblPriceCode')}</TableCell>
                        <TableCell align="right">{t('lblCount')}</TableCell>
                        <TableCell align="left">{t('lblServiceShop')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {BomDataRows.map((row, index) => (
                        <TableRow key={index} style={index % 2 ? { background: "#dcdcdc" } : { background: "white" }}>
                          <TableCell align="left">{row.Ref}</TableCell>
                          <TableCell align="left">{row.MaterialCode}</TableCell>
                          <TableCell align="left">{row.Material}</TableCell>
                          <TableCell align="left">{row.PriceCode}</TableCell>
                          <TableCell align="right">{row.Count}</TableCell>
                          <TableCell align="left">{row.ServiceShop}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  BomListLibrary.propTypes = {
    className: PropTypes.string
  };
  
  export default connect(state => ({ tasks: state.tasks1 }))(BomListLibrary);
  